import { UntypedFormControl } from "@angular/forms";
import moment from "moment";

/**
 * Check if min and max date are valid
 *
 * @param formDate from FormControl
 */
export function checkedMinMaxDateValidator(
  formDate: UntypedFormControl
): { [key: string]: any } | null {
  if (
    formDate?.parent?.controls["startDate"] &&
    formDate?.parent?.controls["endDate"]
  ) {
    if (
      moment(formDate.parent.controls["startDate"].value).isAfter(
        formDate.parent.controls["endDate"].value
      )
    ) {
      return { invalideDate: true };
    } else if (
      moment(formDate.parent.controls["endDate"].value).isBefore(
        formDate.parent.controls["startDate"].value
      )
    ) {
      return { invalideDate: true };
    } else {
      return null;
    }
  } else {
    return null;
  }
}
